<script>
  import LoteEntidadeService from '../../../../../domain/leiloes/services/lote-entidade'
  import PopupViewer from '../../../../_default/components/popup-viewer/PopupViewer'

  export default {
    name: 'GerenciamentoEntidadeLote',
    components: {
      PopupViewer,
      NovaEntidadeLote: () => import('./NovaEntidadeLote')
    },
    data () {
      return {
        entidades: [],
        entidadesLoading: false,
        showEntidadeForm: false,
        entidadeSendoEditada: null,
        loteEntidadeOptions: [
          {label: 'Considerar', value: true, class: 'btn-default'},
          {label: 'Desconsiderar', value: false, class: 'btn-default'}
        ]
      }
    },
    created () {
      this.init()
    },
    mounted () {
      this.carregarEntidadesLote()
    },
    filters: {
      upper (str) {
        if (!str) {
          return ''
        }
        return str.toUpperCase()
      }
    },
    methods: {
      init () {
        this.$nextTick(() => {
          let tableEntidadesHead = this.$el.querySelector('#tableEntidadesHead')
          let tableEntidadesBody = this.$el.querySelector('#tableEntidades')
          console.log(tableEntidadesBody.clientWidth, tableEntidadesHead.clientWidth)
          tableEntidadesHead.style.width = tableEntidadesBody.clientWidth + 'px'
        })
      },
      carregarEntidadesLote () {
        this.entidadesLoading = true
        LoteEntidadeService.getEntidadesLote(this.$route.params.id)
          .then(response => {
            // this.$set(this.lote, 'entidades', response.data)
            this.entidades = response.data
            this.entidadesLoading = false
          })
          .catch(error => {
            alert('Erro ao carregar as entidades')
            alert(error.data.errors)
            console.log(error)
            this.entidadesLoading = false
          })
      },
      atualizaStatusConsiderarEntidade (index) {
        const entidade = this.entidades[index]
        const {id, considerar} = entidade
        LoteEntidadeService.atualizaStatusConsiderarEntidade(id, considerar)
          .then((response) => {
            console.log(response)
          })
          .catch((response) => {
            window.alert(`Não foi possível atualizar o status para "${considerar && 'Considerar' || 'Desconsiderar'}", algum problema ocorreu, tente novamente.`)
            entidade.considerar = !entidade.considerar
            console.log(response)
          })
      },
      openEntidadeForm (evt, id = null) {
        this.entidadeSendoEditada = id
        this.showEntidadeForm = true
      },
      closeEntidadeForm () {
        this.carregarEntidadesLote()
        this.showEntidadeForm = false
        this.entidadeSendoEditada = null
      },
      deletarEntidadeLote (evt, id) {
        this.$loaderOverlay.open('Excluindo...')
        LoteEntidadeService.deleteEntidadeLote(id)
          .then(response => {
            this.$loaderOverlay.hide()
            this.carregarEntidadesLote()
          })
          .catch(error => {
            console.log(error)
            alert('Ocorreu um erro ao tentar excluir essa entidade')
            this.$loaderOverlay.hide()
          })
      }
    }
  }
</script>

<template>
  <div class="wrapper-sm no-padder m-b">
    <div class=" bg-black">
      <div class="wrapper-sm bg-dark font-bold text-uppercase">
        Entidades <u-button @click.prevent="openEntidadeForm" class="btn btn-info btn-xs pull-right m-b" ><i class="fa fa-plus"></i> CADASTRAR NOVA ENTIDADE</u-button>
      </div>
      <div class="bg-black pos-rlt" id="tableEntidadesHead">
        <table class="table table-black bg-black m-b-none">
          <thead>
          <tr>
            <th style="width: 25%">Entidade</th>
            <th style="width: 25%">Opções</th>
          </tr>
          </thead>
        </table>
      </div>
      <div class="scroll-black scroll-lote">
        <table class="table table-black" id="tableEntidades" style="margin-top: -36px">
          <thead>
          <tr>
            <th style="width: 25%">Entidade</th>
            <th style="width: 25%">Opções</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(entidade, index) in entidades" v-if="!entidadesLoading">
            <td>
              <div>({{entidade.tipo && entidade.tipo.nome || '-'}})</div>
              <div>{{(entidade.nome || '(nome não informado)') | upper}}</div>
              <div>{{(entidade.endereco || '(endereco não informado)')|upper}} {{entidade.numero || '(numero não informado)'}} {{(entidade.complemento || '(complemento não informado)')|upper}} {{(entidade.bairro || '(bairro não informado)')|upper}}</div>
              <div>{{(entidade.estado || '(estado não informado)')|upper}} - {{(entidade.cidade || '(cidade não informada)')|upper}} {{(entidade.cep || '(cep não informado)')| formataCep}}</div>
            </td>
            <td>
              <u-button-group @change="atualizaStatusConsiderarEntidade(index)" class="hidden-print" v-model="entidade.considerar"
                              :options="loteEntidadeOptions">

              </u-button-group>

              <u-button class="btn btn-sm btn-info pull-none-xs hidden-print  m-l-sm" tabindex="1"
                        @click.prevent="openEntidadeForm(null, entidade.id)">Editar
              </u-button>
              <u-button class="btn btn-sm btn-danger pull-none-xs hidden-print  m-l-sm" tabindex="1"
                        @click.prevent="deletarEntidadeLote(null, entidade.id)">Excluir
              </u-button>
            </td>
          </tr>
          <tr v-if="(entidades && !entidades.length) && !entidadesLoading">
            <td colspan="4" class="no-borders" style="border-bottom: none"><span class="text-danger">Nenhuma entidade encontrada</span>
            </td>
          </tr>
          <tr v-if="entidadesLoading">
            <td colspan="4" class="no-borders text-center" style="border-bottom: none"><i
              class="fa fa-spin fa-spinner m-t fa-2x"></i></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--<a @click="openEntidadeForm" class="btn btn-info m-b">Cadastrar entidade</a>-->
    <popup-viewer @close="closeEntidadeForm" v-if="showEntidadeForm" :title="`Edição de dados de Entidade`">
      <NovaEntidadeLote @finishSubmit="closeEntidadeForm" @cancel="closeEntidadeForm" :entidadeId="entidadeSendoEditada"/>
    </popup-viewer>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// GerenciamentoEntidadeLote.vue?93cd477a